import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-388855a3")
const _hoisted_1 = { class: "px-8 d-flex align-items-center justify-content-center min-w-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm dropdown-toggle d-flex justify-content-between align-items-center",
  type: "button",
  id: "columns-dropdown",
  "data-bs-toggle": "dropdown",
  "data-bs-auto-close": "outside",
  "aria-expanded": "false"
}, " Columns ", -1)
const _hoisted_3 = { class: "dropdown-menu py-0 rounded overflow-hidden mt-n1" }
const _hoisted_4 = { class: "card w-300px m-0 p-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header px-2 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0 ms-6" }, "Show / Hide Columns")
], -1)
const _hoisted_6 = { class: "card-body px-2 py-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs-8 m-0 ms-4" }, [
    /*#__PURE__*/_createElementVNode("text", { class: "fs-8 fw-bold" }, "Please be aware"),
    /*#__PURE__*/_createTextVNode(" that increasing the number of visible columns will slow your loading speed. ")
  ])
], -1)
const _hoisted_8 = {
  id: "columns-dropdown-list",
  class: "p-0",
  "aria-labelledby": "rows-per-page-select"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-5 opacity-0" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input form-check-custom form-check-blue ms-0 me-4 cursor-pointer",
  type: "checkbox",
  checked: ""
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "position-absolute end-0 top-50 translate-middle-y me-4",
  width: "9",
  height: "17",
  viewBox: "0 0 9 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.15527 3.01556L6.9178 5.83333L8.14656 4.58L4.15527 0.5L0.155273 4.58L1.39275 5.83333L4.15527 3.01556ZM4.15527 13.9844L1.39275 11.1667L0.163988 12.42L4.15527 16.5L8.15527 12.42L6.9178 11.1667L4.15527 13.9844Z",
    fill: "#323232"
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-5 opacity-0" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"m-0 ms-4\" data-v-388855a3><p class=\" fw-bold fs-6\" data-v-388855a3>Freeze Columns:</p><div class=\"d-flex\" data-v-388855a3><div class=\"d-flex w-50 gap-2 align-items-center\" data-v-388855a3><p class=\"m-0 h-max-cont\" data-v-388855a3>Left:</p><input type=\"text\" class=\"form-control h-50px w-50px input-bg text-center\" value=\"1\" data-v-388855a3></div><div class=\"d-flex w-50 gap-2 align-items-center\" data-v-388855a3><p class=\"m-0 h-max-cont\" data-v-388855a3>Right:</p><input type=\"text\" class=\"form-control h-50px w-50px input-bg text-center\" value=\"1\" data-v-388855a3></div></div></div>", 1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "card-footer px-6 py-4 d-flex" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm m-0 me-6 ml-auto action-button-2" }, "Confirm")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("ul", _hoisted_8, [
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: header + index,
                class: "w-100 d-flex metronic-dropdown-item ms-0 mt-0 cursor-grab position-relative"
              }, [
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(header) + " ", 1),
                _hoisted_11
              ]))
            }), 128)),
            _hoisted_12
          ]),
          _hoisted_13
        ]),
        _hoisted_14
      ])
    ])
  ]))
}